export default "__VITE_ASSET__CBUI$SUb__"